import React from 'react';
import { reorder } from 'react-reorder';
import './index.css';

import { 
      _getLeafPages,
      _postReorderLeafPage
    
    } from '../../services';

import Leaf from './leaf-page';
import Group from './group-page';
import { message } from 'antd';

class LeafPage extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      currentPage: "leaf-pages",
      currentLeafPage: "",
      currentIndex: Number,

      list: []
    }

    this.onReorderLeaf = this.onReorderLeaf.bind(this);
    this.onLeafEdit = this.onLeafEdit.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.updateData = this.updateData.bind(this);
    this.updateCurrentLeafPage = this.updateCurrentLeafPage.bind(this);
  }

  componentDidMount() {
    this.updateData();
  }

  render() {


    return (
      <div className="page">
        {this.currentPage()}
      </div>
    )
  }

  currentPage() {
    if (this.state.currentPage === 'leaf-pages')
      return (
        <Leaf 
          list={this.state.list} 
          onReorderLeaf={this.onReorderLeaf}
          onLeafEdit={this.onLeafEdit}
          updateData={this.updateData}
        />
      )
    if (this.state.currentPage === 'group-pages')
      return (
        <Group 
          updateData={this.updateData}
          onPageChange={this.onPageChange}
          currentLeafPage={this.state.currentLeafPage}
          onReorderGroup={this.onReorderGroup}
          updateCurrentLeafPage={this.updateCurrentLeafPage}
        />
      )
  }

  onReorderLeaf( event, previousIndex, nextIndex, fromId, toId ) {

    let newList = reorder(this.state.list, previousIndex, nextIndex);
    
    newList.map(( item, index ) => {  //reindex the list
      item.position = index;
      return item;
    })
    
    _postReorderLeafPage( newList )
      .then(res => {
        this.updateData();
        message.success('List reordered!', 2);
      })
      .catch(err => {
        message.error('List reordering failed.', 2);
        console.log(err);
      })
  }


  onLeafEdit(index) {
    const list = this.state.list;
    this.setState({
      currentPage: 'group-pages',
      currentLeafPage: list[index],
      currentIndex: index
    })
  }

  onPageChange( toPage ) {
    this.setState({
      currentPage: toPage
    })

    if (toPage === 'leaf-pages')
      this.setState({
        currentLeafPage: {},
        currentIndex: Number,
      })

    this.updateData();
  }

  updateCurrentLeafPage = ( newLeaf ) => {
    this.setState({
      currentLeafPage: newLeaf
    })
  }

  updateData = () => {
    _getLeafPages()
      .then(res => {
        let list = res.data.data;

        this.setState({
          list: list,
          currentLeafPage: list[this.state.currentIndex]
        })
      })
      .catch(err => console.error(err));
  }

}

export default LeafPage;


// WEBPACK FOOTER //
// ./src/components/leaf-page/index.js